"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundRedemptInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var FundRedemptInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FundRedemptInit, _super);
    function FundRedemptInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '基金赎回初始化';
        _this.code = '106008';
        _this.desc = '基金赎回初始化';
        _this.requestParams = new zl_1.FundRedemptInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FundRedemptInit;
}(service_1.BaseService));
exports.FundRedemptInit = FundRedemptInit;
//# sourceMappingURL=fundRedemptInit.js.map